<div class="vd-page">
  <div class="container-fluid px-4">

    <!-- Back -->
    <div class="vd-back mt-3" (click)="goBack()" *ngIf="!isWorkflowTaskView">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="#532E60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      Go back to Vendors
    </div>

    <!-- Title Row -->
    <div class="vd-title-row mt-2 d-flex align-items-center justify-content-between flex-wrap gap-2">
      <div>
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <h2 class="vd-name mb-0">{{ vendorName || vendorId }}</h2>
          <span class="vd-id-badge">{{ vendorId }}</span>
          <span class="vd-status-badge" [ngClass]="vendorStatusClass">{{ vendorStatus }}</span>
        </div>
        <div class="vd-breadcrumb mt-1" *ngIf="!isWorkflowTaskView">
          <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="bc-link">Dashboard</a>
          <span class="bc-sep"> &rsaquo; </span>
          <a [routerLink]="['/' + AppConstants.ROUTES.VENDORS]" class="bc-link">Manage Vendors</a>
          <span class="bc-sep"> &rsaquo; </span>
          <span class="bc-current">Vendor Details</span>
        </div>
      </div>
      <button class="invite-btn" (click)="confirmInviteVendor()" *ngIf="!isWorkflowTaskView">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8.5" cy="7" r="4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 8V14M23 11H17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        Invite
      </button>
    </div>

    <div class="section-card mt-3" *ngIf="isWorkflowTaskView && workflowData && workflowChildTasks.length">
      <div class="workflow-card-header">
        <h5 class="section-title mb-0">Vendor Review Task</h5>
      </div>

      <div class="workflow-task-list">
        <div class="workflow-task-item" *ngFor="let task of workflowChildTasks">
          <div>
            <strong>{{ getWorkflowValue(task, ['title', 'Title']) || 'Vendor review task' }}</strong>
            <span>{{ getWorkflowValue(task, ['assignedToEmail', 'AssignedToEmail']) }}</span>
            <p *ngIf="getWorkflowValue(task, ['description', 'Description'])">{{ getWorkflowValue(task, ['description', 'Description']) }}</p>
            <div *ngIf="getWorkflowValue(task, ['completionComments', 'CompletionComments'])">
              <hr/>
              <p class="workflow-task-comments">
                {{ getWorkflowValue(task, ['completionComments', 'CompletionComments']) }}
              </p>
            </div>
          </div>
          <div class="workflow-task-actions">
            <span class="wf-status-badge" [ngClass]="getWorkflowTaskStatusClass(task)">{{ getWorkflowValue(task, ['status', 'Status']) }}</span>
            <button
              class="workflow-approve-btn"
              type="button"
              *ngIf="getWorkflowValue(task, ['canComplete', 'CanComplete']) === true"
              (click)="completeWorkflowChildTask(task, 'Approved')">
              Approve Task
            </button>
            <button
              class="workflow-reject-btn"
              type="button"
              *ngIf="getWorkflowValue(task, ['canComplete', 'CanComplete']) === true"
              (click)="openRejectWorkflowChildTask(task)">
              Reject Task
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs -->
    <div class="tabs-navigation mt-3">
      <div class="tabs-container">
        <button class="tab-item" [class.active]="activeTab === 'Application'" (click)="loadTab('Application')">Application</button>
        <button class="tab-item" [class.active]="activeTab === 'Contacts'" (click)="loadTab('Contacts')">Contacts</button>
        <button class="tab-item" [class.active]="activeTab === 'BankAccounts'" (click)="loadTab('BankAccounts')">Bank Accounts</button>
        <button class="tab-item" [class.active]="activeTab === 'Workflow'" (click)="loadTab('Workflow')">Workflow</button>
      </div>
    </div>

    <!-- =================== APPLICATION TAB =================== -->
    <ng-container *ngIf="activeTab === 'Application'">
      <!-- Stepper -->
      <div class="vendor-progress mt-3" *ngIf="applicationData">
        <div class="step-container">
          <ng-container *ngFor="let s of steps; let i = index">
            <div class="step" (click)="currentStep = i">
              <div class="circle" [ngClass]="{
                'active': currentStep > i,
                'current': currentStep === i,
                'dotted': currentStep < i
              }">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                </svg>
              </div>
              <div class="step-title">
                <p>{{ s }}</p>
              </div>
            </div>
            <div class="line-segment" *ngIf="i < steps.length - 1" [class.active]="currentStep > i"></div>
          </ng-container>
        </div>

        <div class="erp-banner my-3" >
          <span><strong>ERP Vendor ID:</strong> {{ val(applicationData.erpVendorID) }}</span>
        </div>
        
      </div>

      <!-- Step Content -->
      <div class="step-content mt-3" *ngIf="applicationData">
        <ng-container *ngIf="isIndividualVendor">
          <!-- Step 0: Personal Information -->
          <ng-container *ngIf="currentStep === 0">
            <div class="section-card">
              <h5 class="section-title">Account Details</h5>
              <div class="field-grid">
                <div class="field-group"><label>Account Type</label><div class="field-value">{{ getApplicationDisplayValue(['vendorType', 'VendorType']) }}</div></div>
                <div class="field-group"><label>Local / Foreign</label><div class="field-value">{{ getApplicationDisplayValue(['localOrForeign', 'LocalOrForeign']) }}</div></div>
                <div class="field-group"><label>Person Name</label><div class="field-value">{{ getApplicationDisplayValue(['name', 'vendorName', 'VendorName']) }}</div></div>
                <div class="field-group"><label>Vendor ID</label><div class="field-value">{{ getApplicationDisplayValue(['vendorID', 'VendorID']) }}</div></div>
              </div>
            </div>

            <div class="section-card">
              <h5 class="section-title">Personal Information</h5>
              <div class="field-grid">
                <div class="field-group"><label>Full Name</label><div class="field-value">{{ getApplicationDisplayValue(['name', 'vendorName', 'VendorName']) }}</div></div>
                <div class="field-group"><label>National ID / Passport No.</label><div class="field-value">{{ getApplicationDisplayValue(['nationalIdPassport', 'qatid', 'passport', 'QATID', 'Passport']) }}</div></div>
                <div class="field-group"><label>Nationality</label><div class="field-value">{{ getApplicationDisplayValue(['nationalityName', 'NationalityName', 'nationality', 'Nationality']) }}</div></div>
                <div class="field-group"><label>Date of Birth</label><div class="field-value">{{ formatDate(applicationData.dateOfBirth || applicationData.DateOfBirth) }}</div></div>
                <div class="field-group"><label>Gender</label><div class="field-value">{{ getApplicationDisplayValue(['gender', 'Gender']) }}</div></div>
                <div class="field-group"><label>Mobile Number</label><div class="field-value">{{ getApplicationDisplayValue(['mobileNumber', 'MobileNumber', 'mobile', 'Mobile', 'phonePrimary', 'PhonePrimary']) }}</div></div>
                <div class="field-group"><label>Email Address</label><div class="field-value">{{ getApplicationDisplayValue(['emailAddress', 'EmailAddress', 'email', 'Email']) }}</div></div>
              </div>
            </div>

            <div class="section-card">
              <h5 class="section-title purple">Residential Address</h5>
              <div class="field-grid">
                <div class="field-group col-full"><label>Residential Address</label><div class="field-value">{{ getApplicationDisplayValue(['residentialAddress', 'ResidentialAddress', 'addressDescriptionPrimary', 'AddressDescriptionPrimary', 'streetPrimary', 'StreetPrimary']) }}</div></div>
                <div class="field-group"><label>City</label><div class="field-value">{{ getApplicationDisplayValue(['city', 'City', 'cityPrimary', 'CityPrimary']) }}</div></div>
                <div class="field-group"><label>Country</label><div class="field-value">{{ getApplicationDisplayValue(['countryName', 'CountryName', 'countryRegionIdPrimaryName', 'CountryRegionIdPrimaryName', 'country', 'Country']) }}</div></div>
              </div>
            </div>
          </ng-container>

          <!-- Step 1: Business Information -->
          <ng-container *ngIf="currentStep === 1">
            <div class="section-card">
              <h5 class="section-title">Business Information</h5>
              <div class="field-grid">
                <div class="field-group"><label>Trading Name (if any)</label><div class="field-value">{{ getApplicationDisplayValue(['tradingName', 'TradingName']) }}</div></div>
                <div class="field-group"><label>Type of Business Activity</label><div class="field-value">{{ getApplicationDisplayValue(['typeOfBusinessActivity', 'TypeOfBusinessActivity']) }}</div></div>
                <div class="field-group"><label>Years of Experience</label><div class="field-value">{{ getApplicationDisplayValue(['yearsOfExperience', 'YearsOfExperience']) }}</div></div>
                <div class="field-group col-full"><label>Description of Goods/Services Offered</label><div class="field-value textarea-val">{{ getApplicationDisplayValue(['descriptionOfGoodsServices', 'DescriptionOfGoodsServices', 'description', 'Description']) }}</div></div>
              </div>
            </div>
          </ng-container>


          <!-- Step 2: Tax & Legal -->
          <ng-container *ngIf="currentStep === 2">
            <div class="section-card">
              <h5 class="section-title">Tax & Legal</h5>
              <div class="field-grid">
                <div class="field-group"><label>Tax Identification Number</label><div class="field-value">{{ getApplicationDisplayValue(['taxIdentificationNumber', 'TaxIdentificationNumber', 'taxId', 'TaxId']) }}</div></div>
                <div class="field-group"><label>VAT Registration No.</label><div class="field-value">{{ getApplicationDisplayValue(['vatRegistrationNumber', 'VatRegistrationNumber', 'vatNumber', 'VatNumber']) }}</div></div>
                <div class="field-group"><label>Country of Tax Residence</label><div class="field-value">{{ getApplicationDisplayValue(['countryOfTaxResidenceName', 'CountryOfTaxResidenceName', 'countryOfTaxResidence', 'CountryOfTaxResidence', 'taxResidenceCountry', 'TaxResidenceCountry']) }}</div></div>
              </div>
            </div>
          </ng-container>

          <!-- Step 3: Supporting Documents -->
          <ng-container *ngIf="currentStep === 3">
            <div class="section-card">
              <h5 class="section-title">Supporting Documents</h5>
              <div class="doc-groups" *ngIf="supportingDocGroups.length; else noIndividualDocs">
                <div class="doc-group-card" *ngFor="let group of supportingDocGroups">
                  <div class="doc-group-header">
                    <span class="doc-group-label">{{ group.label }}</span>
                    <span class="doc-count-badge">{{ group.files.length }} {{ group.files.length === 1 ? 'file' : 'files' }}</span>
                  </div>
                  <div class="doc-file" *ngFor="let f of group.files">
                    <span class="doc-filename">{{ f.name }}</span>
                    <span class="doc-expiry">Expiry: {{ f.documentExpiryDate ? formatDate(f.documentExpiryDate) : '-' }}</span>
                    <div class="doc-actions">
                      <a [href]="f.fileContent" target="_blank" class="doc-btn view-btn">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="#532E60" stroke-width="2"/><circle cx="12" cy="12" r="3" stroke="#532E60" stroke-width="2"/></svg>
                        View
                      </a>
                      <a [href]="f.fileContent" download class="doc-btn dl-btn">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#532E60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 10L12 15L17 10" stroke="#532E60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 15V3" stroke="#532E60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        Download
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noIndividualDocs><p class="empty-text">No documents uploaded.</p></ng-template>
            </div>
          </ng-container>
          <!-- Step 4: Other -->
          <ng-container *ngIf="currentStep === 4">
            <div class="section-card">
              <h5 class="section-title">Other Information</h5>
              <div class="field-grid">
                <div class="field-group col-full">
                  <label>Provide any other information that you think Bidaya should consider as part of your application:</label>
                  <div class="field-value textarea-val">{{ getApplicationDisplayValue(['otherInformation', 'OtherInformation']) }}</div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!isIndividualVendor">
          <!-- Step 0: Supplier Information -->
        <ng-container *ngIf="currentStep === 0">
          <div class="section-card">
            <h5 class="section-title">Account Details</h5>
            <div class="field-grid">
              <div class="field-group"><label>Account Type</label><div class="field-value">{{ val(applicationData.vendorType) }}</div></div>
              <div class="field-group"><label>Local / Foreign</label><div class="field-value">{{ val(applicationData.localOrForeign) }}</div></div>
              <div class="field-group"><label>Company Name</label><div class="field-value">{{ val(applicationData.name) }}</div></div>
              <div class="field-group"><label>Vendor ID</label><div class="field-value">{{ val(applicationData.vendorID) }}</div></div>
            </div>
          </div>

          <div class="section-card">
            <h5 class="section-title">Company Information</h5>
            <div class="field-grid">
              <div class="field-group"><label>Company Name</label><div class="field-value">{{ val(applicationData.name) }}</div></div>
              <div class="field-group"><label>Nature of Business</label><div class="field-value">{{ val(applicationData.natureOfBusiness) }}</div></div>
              <div class="field-group col-full"><label>Company Nature</label><div class="field-value">{{ val(applicationData.companyType) }}</div></div>
            </div>
          </div>

          <div class="section-card">
            <h5 class="section-title purple">Main Office / Headquarters: Correspondence Address</h5>
            <div class="field-grid">
              <div class="field-group"><label>P.O. Box</label><div class="field-value">{{ val(applicationData.poBox) }}</div></div>
              <div class="field-group"><label>State / Region / Province</label><div class="field-value">{{ val(applicationData.state) }}</div></div>
              <div class="field-group"><label>Street Name</label><div class="field-value">{{ val(applicationData.streetPrimary) }}</div></div>
              <div class="field-group"><label>Country</label><div class="field-value">{{ val(applicationData.countryRegionIdPrimaryName) }}</div></div>
              <div class="field-group"><label>Zone No.</label><div class="field-value">{{ val(applicationData.zoneNo) }}</div></div>
              <div class="field-group"><label>Telephone No.</label><div class="field-value">{{ val(applicationData.phonePrimary) }}</div></div>
              <div class="field-group"><label>Street No.</label><div class="field-value">{{ val(applicationData.streetNo) }}</div></div>
              <div class="field-group"><label>Fax No.</label><div class="field-value">{{ val(applicationData.fax) }}</div></div>
              <div class="field-group"><label>Building No.</label><div class="field-value">{{ val(applicationData.buildingNo) }}</div></div>
              <div class="field-group"><label>Email</label><div class="field-value">{{ val(applicationData.email) }}</div></div>
              <div class="field-group"><label>City</label><div class="field-value">{{ val(applicationData.cityPrimary) }}</div></div>
              <div class="field-group"><label>Website</label><div class="field-value">{{ val(applicationData.website) }}</div></div>
            </div>
          </div>

          <div class="section-card">
            <h5 class="section-title">Establishment and Employees</h5>
            <div class="field-grid">
              <div class="field-group"><label>Country of Establishment</label><div class="field-value">{{ val(applicationData.establishmentCountryName) }}</div></div>
              <div class="field-group"><label>Year of Establishment</label><div class="field-value">{{ val(applicationData.establishmentYear) }}</div></div>
              <div class="field-group col-full"><label>Number of Employees</label><div class="field-value">{{ val(applicationData.noOfEmployees) }}</div></div>
            </div>
          </div>

          <div class="section-card">
            <h5 class="section-title">Parent Company</h5>
            <div class="field-grid">
              <div class="field-group col-full"><label>Parent Company Name (if different to above)</label><div class="field-value">{{ val(applicationData.parentCompanyPreviousName) }}</div></div>
            </div>
          </div>

          <div class="section-card" *ngIf="applicationData.subsidiaries?.length">
            <h5 class="section-title">Subsidiaries</h5>
            <table class="vd-table">
              <thead><tr><th>#</th><th>Subsidiary Name</th><th>Relationship to Parent</th></tr></thead>
              <tbody>
                <tr *ngFor="let s of applicationData.subsidiaries; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ s.subsidiaryName }}</td>
                  <td>{{ s.relationshipToParent }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="section-card">
            <h5 class="section-title">Additional Information</h5>
            <div class="field-grid">
              <div class="field-group"><label>Commercial Registration Number</label><div class="field-value">{{ val(applicationData.commercialRegNumber) }}</div></div>
              <div class="field-group"><label>Chamber of Commerce Membership Number</label><div class="field-value">{{ val(applicationData.chamberMembershipNumber) }}</div></div>
              <div class="field-group col-full"><label>Commercial License Number</label><div class="field-value">{{ val(applicationData.importLicenseNumber) }}</div></div>
              <div class="field-group col-full"><label>ISO Certification</label><div class="field-value">{{ val(applicationData.isoCertification) }}</div></div>
            </div>
          </div>
        </ng-container>

        <!-- Step 1: Company Ownership -->
        <ng-container *ngIf="currentStep === 1">
          <div class="section-card">
            <h5 class="section-title">Owner</h5>
            <div class="field-grid">
              <div class="field-group"><label>Name of Owner</label><div class="field-value">{{ val(applicationData.ownerName) }}</div></div>
              <div class="field-group"><label>Nationality</label><div class="field-value">{{ val(applicationData.ownerNationalityName) }}</div></div>
            </div>
          </div>

          <div class="section-card" *ngIf="applicationData.partners?.length">
            <h5 class="section-title">Partners / Co-Owners</h5>
            <table class="vd-table">
              <thead><tr><th>#</th><th>Name</th><th>% Share</th><th>Nationality</th><th>ID/CR Number</th></tr></thead>
              <tbody>
                <tr *ngFor="let p of applicationData.partners; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ p.name }}</td>
                  <td>{{ p.percentageOfShare }}</td>
                  <td>{{ p.nationalityName || p.nationality }}</td>
                  <td>{{ p.idNumber }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="section-card" *ngIf="applicationData.managementTeam?.length">
            <h5 class="section-title">Senior Management</h5>
            <table class="vd-table">
              <thead><tr><th>#</th><th>Name</th><th>Title</th><th>Nationality</th><th>Email</th><th>Phone</th><th>Mobile</th></tr></thead>
              <tbody>
                <tr *ngFor="let m of applicationData.managementTeam; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ m.name }}</td>
                  <td>{{ m.title }}</td>
                  <td>{{ m.nationalityName || m.nationality }}</td>
                  <td>{{ m.email }}</td>
                  <td>{{ val(m.landlineNumber) }}</td>
                  <td>{{ val(m.mobileNumber) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <!-- Step 2: Financial Details -->
        <ng-container *ngIf="currentStep === 2">
          <div class="section-card">
            <div class="field-grid three-col">
              <div class="field-group"><label>Currency</label><div class="field-value">{{ val(applicationData.currency) }}</div></div>
              <div class="field-group"><label>Authorized Capital</label><div class="field-value">{{ val(applicationData.authorizedCapital) }}</div></div>
              <div class="field-group"><label>Working Capital</label><div class="field-value">{{ val(applicationData.workingCapital) }}</div></div>
              <div class="field-group"><label>Credit Rating</label><div class="field-value">{{ val(applicationData.creditRating) }}</div></div>
              <div class="field-group"><label>Net Profit</label><div class="field-value">{{ val(applicationData.netProfit) }}</div></div>
              <div class="field-group"><label>Total Assets</label><div class="field-value">{{ val(applicationData.totalAssets) }}</div></div>
              <div class="field-group"><label>Current Ratio: (Current Assets / Liabilities)</label><div class="field-value">{{ val(applicationData.currentRatio) }}</div></div>
              <div class="field-group"><label>Latest Annual Turnover</label><div class="field-value">{{ val(applicationData.latestAnnualTurnover) }}</div></div>
            </div>
          </div>

          <div class="section-card" *ngIf="annualTurnovers.length">
            <h5 class="section-title">Annual Turnover</h5>
            <div class="field-group mb-3"><label>Current Year</label><div class="field-value">{{ getApplicationDisplayValue(['currentYear', 'CurrentYear']) }}</div></div>
            <table class="vd-table">
              <thead><tr><th>Year No.</th><th>Year</th><th>Value</th></tr></thead>
              <tbody>
                <tr *ngFor="let t of annualTurnovers">
                  <td>YR {{ getAnnualTurnoverYearNumber(t) }}</td>
                  <td>{{ getAnnualTurnoverDisplayYear(t) }}</td>
                  <td>{{ getWorkflowValue(t, ['turnoverAmount', 'TurnoverAmount', 'value', 'Value']) || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <!-- Step 3: Capability & Experience -->
        <ng-container *ngIf="currentStep === 3">
          <div class="section-card" *ngIf="selectedCategoryTreeData.length > 0">
            <h5 class="section-title">Selected Categories / Subcategories</h5>
            <div class="selected-category-tree">
              <div *ngFor="let category of selectedCategoryTreeData" class="tree-category-wrapper">
                <div class="tree-category-row" [class.has-children]="category.subCategories.length">
                  <div class="tree-category-content">
                    <span class="tree-check-icon"><i class="bi bi-check-circle-fill"></i></span>
                    <label class="tree-category-label">{{ category.label }}</label>
                  </div>
                  <button
                    type="button"
                    class="tree-expand-btn"
                    *ngIf="category.subCategories.length"
                    (click)="toggleCategoryExpand(category.id)"
                    [attr.aria-expanded]="isCategoryExpanded(category.id)"
                    aria-label="Toggle category">
                    <i [class]="isCategoryExpanded(category.id) ? 'bi bi-chevron-down' : 'bi bi-chevron-right'"></i>
                  </button>
                </div>

                <div class="tree-subcategories-wrapper" *ngIf="isCategoryExpanded(category.id) && category.subCategories.length">
                  <div *ngFor="let subCategory of category.subCategories" class="tree-subcategory-wrapper">
                    <div class="tree-subcategory-row" [class.has-children]="subCategory.items.length">
                      <div class="tree-subcategory-content">
                        <span class="tree-check-icon"><i class="bi bi-check-circle-fill"></i></span>
                        <label class="tree-subcategory-label">{{ subCategory.label }}</label>
                      </div>
                      <button
                        type="button"
                        class="tree-expand-btn"
                        *ngIf="subCategory.items.length"
                        (click)="toggleSubCategoryExpand(subCategory.id)"
                        [attr.aria-expanded]="isSubCategoryExpanded(subCategory.id)"
                        aria-label="Toggle subcategory">
                        <i [class]="isSubCategoryExpanded(subCategory.id) ? 'bi bi-chevron-down' : 'bi bi-chevron-right'"></i>
                      </button>
                    </div>

                    <div class="tree-subsubcategories-wrapper" *ngIf="isSubCategoryExpanded(subCategory.id) && subCategory.items.length">
                      <div *ngFor="let item of subCategory.items" class="tree-subsubcategory-row">
                        <span class="tree-check-icon"><i class="bi bi-check-circle-fill"></i></span>
                        <label class="tree-subsubcategory-label">{{ item.label }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section-card">
            <div class="field-grid">
              <div class="field-group col-full"><label>Core Products / Services Offered</label><div class="field-value textarea-val">{{ val(applicationData.coreProductsServices) }}</div></div>
              <div class="field-group col-full"><label>Previous Experience</label><div class="field-value textarea-val">{{ val(applicationData.previousExperience) }}</div></div>
              <div class="field-group"><label>Additional Information about Products / Services</label><div class="field-value textarea-val">{{ val(applicationData.additionalInformation) }}</div></div>
              <div class="field-group"><label>Contracts / Projects Details (last 3 years)</label><div class="field-value textarea-val">{{ val(applicationData.contractsProjectsDetails) }}</div></div>
              <div class="field-group col-full"><label>Authorized Representative / Dealer for any Supplier?</label><div class="field-value">{{ val(applicationData.isAuthorizedRepresentative) }}</div></div>
            </div>
          </div>

          <div class="section-card" *ngIf="applicationData.authorizedRepresentatives?.length">
            <h5 class="section-title">Authorized Representatives</h5>
            <table class="vd-table">
              <thead><tr><th>#</th><th>Company</th><th>P.O. Box</th><th>Tel No.</th><th>Fax No.</th><th>Products Represented</th><th>Documents</th></tr></thead>
              <tbody>
                <tr *ngFor="let r of applicationData.authorizedRepresentatives; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ r.company }}</td>
                  <td>{{ r.poBox }}</td>
                  <td>{{ r.telNo }}</td>
                  <td>{{ r.faxNo }}</td>
                  <td>{{ r.productsRepresented }}</td>
                  <td>
                    <ng-container *ngFor="let att of applicationData.attachments">
                      <a *ngIf="att.attachmentFor?.toLowerCase().includes('authorizedrep')" [href]="att.fileContent" target="_blank" class="doc-link">{{ att.name }}</a>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <!-- Step 4: Supporting Documents -->
        <ng-container *ngIf="currentStep === 4">
          <div class="section-card">
            <h5 class="section-title">Supporting Documents</h5>
            <div class="doc-groups" *ngIf="supportingDocGroups.length; else noDocs">
              <div class="doc-group-card" *ngFor="let group of supportingDocGroups">
                <div class="doc-group-header">
                  <span class="doc-group-label">{{ group.label }}</span>
                  <span class="doc-count-badge">{{ group.files.length }} {{ group.files.length === 1 ? 'file' : 'files' }}</span>
                </div>
                <div class="doc-file" *ngFor="let f of group.files">
                  <span class="doc-filename">{{ f.name }}</span>
                  <span class="doc-expiry" *ngIf="f.documentExpiryDate">Expiry: {{ f.documentExpiryDate ? formatDate(f.documentExpiryDate) : '-' }}</span>
                  <div class="doc-actions">
                    <a [href]="f.fileContent" target="_blank" class="doc-btn view-btn">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="#532E60" stroke-width="2"/><circle cx="12" cy="12" r="3" stroke="#532E60" stroke-width="2"/></svg>
                      View
                    </a>
                    <a [href]="f.fileContent" download class="doc-btn dl-btn">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#532E60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 10L12 15L17 10" stroke="#532E60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 15V3" stroke="#532E60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      Download
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noDocs><p class="empty-text">No documents uploaded.</p></ng-template>
          </div>
        </ng-container>

        <!-- Step 5: Warehousing & Storage -->
        <ng-container *ngIf="currentStep === 5">
          <div class="section-card">
            <div class="field-grid">
              <div class="field-group col-full">
                <label>Warehousing and Storage Facilities (including location)</label>
                <div class="field-value textarea-val">{{ val(applicationData.warehousingStorageDetails) }}</div>
              </div>
              <div class="field-group col-full">
                <label>Transport / Freight Forwarding Facilities</label>
                <div class="field-value textarea-val">{{ val(applicationData.transportFreightForwardingDetails) }}</div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Step 6: Other -->
        <ng-container *ngIf="currentStep === 6">
          <div class="section-card">
            <h5 class="section-title">Other Information</h5>
            <div class="field-grid">
              <div class="field-group col-full">
                <label>Provide any other information that you think Bidaya should consider as part of your application:</label>
                <div class="field-value textarea-val">{{ val(applicationData.otherInformation) }}</div>
              </div>
              <div class="field-group"><label>Vendor Status</label><div class="field-value">{{ val(normalizeVendorStatus(applicationData.status || applicationData.Status)) }}</div></div>
              </div>
          </div>
        </ng-container>
        </ng-container>

      </div>

      <!-- Prev / Next -->
      <div class="step-nav" *ngIf="applicationData">
        <button class="nav-btn prev-btn" (click)="currentStep = currentStep - 1" [disabled]="currentStep === 0">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          Previous
        </button>
        <button class="nav-btn next-btn" (click)="currentStep = currentStep + 1" [disabled]="currentStep === steps.length - 1">
          Next
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
    </ng-container>

    <!-- =================== CONTACTS TAB =================== -->
    <ng-container *ngIf="activeTab === 'Contacts'">
      <div class="section-card mt-3" *ngIf="contactsData">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h5 class="section-title mb-0">Contacts</h5>
          <button class="add-contact-btn" *ngIf="canManageContacts" (click)="openAddContact()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M12 5V19M5 12H19" stroke="white" stroke-width="2.5" stroke-linecap="round"/></svg>
            Add Contact
          </button>
        </div>
        <table class="vd-table" *ngIf="contactsData.contactPerson?.length; else noContacts">
          <thead>
            <tr>
              <th>#</th><th>Name</th><th>Title</th><th>Email</th><th>Mobile</th>
              <th>Landline</th><th>Role</th><th>Prompt password change</th><th *ngIf="canManageContacts">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of contactsData.contactPerson; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ c.name }}</td>
              <td>{{ val(c.title) }}</td>
              <td>{{ c.email }}</td>
              <td>{{ val(c.mobileNumber) }}</td>
              <td>{{ val(c.landlineNumber) }}</td>
              <td><span class="role-badge" [ngClass]="c.contactType?.toLowerCase()">{{ c.contactType }}</span></td>
              <td><span class="badge-no">{{ c.promotPasswordChange ? 'Yes' : 'No' }}</span></td>
              <td *ngIf="canManageContacts">
                <div class="contact-actions">
                  <button class="ca-btn edit-btn" (click)="openEditContact(c)">Edit</button>
                  <!-- <button class="ca-btn password-btn" (click)="openPasswordModal(c)">Password</button> -->
                  <button class="ca-btn role-btn secondary-btn" *ngIf="c.contactType === 'Primary'" (click)="setContactAsSecondary(c)">Set as Secondary</button>
                  <button class="ca-btn role-btn primary-btn" *ngIf="canSetContactAsPrimary(c)" (click)="setContactAsPrimary(c)">Set as Primary</button>
                  <button class="ca-btn invite-contact-btn" *ngIf="canInviteContact(c)" (click)="confirmInviteContact(c)">Invite</button>
                  <button class="ca-btn remove-btn" *ngIf="c.contactType !== 'Primary'" (click)="openRemoveContactModal(c)">Remove</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-template #noContacts><p class="empty-text">No contacts found.</p></ng-template>
      </div>
    </ng-container>

    <!-- =================== CONTACT MODAL =================== -->
    <div class="contact-modal-overlay" *ngIf="showContactModal" (click)="closeContactModal()"></div>
    <div class="contact-modal" *ngIf="showContactModal">
      <div class="contact-modal-header">
        <h5 class="mb-0">{{ contactModalMode === 'add' ? 'Add Contact Person' : 'Edit Contact Person' }}</h5>
        <button class="modal-close-btn" (click)="closeContactModal()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="#333" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="contact-modal-body">
        <div class="cm-field-grid">
          <div class="cm-field-group">
            <label>Full Name</label>
            <input type="text" class="cm-input" [(ngModel)]="contactForm.name" placeholder="Enter full name" />
          </div>
          <div class="cm-field-group">
            <label>Title</label>
            <input type="text" class="cm-input" [(ngModel)]="contactForm.title" placeholder="e.g. Manager" />
          </div>
          <div class="cm-field-group">
            <label>Email <span class="required-star">*</span></label>
            <input type="email" class="cm-input" [(ngModel)]="contactForm.email" placeholder="email@example.com" />
          </div>
          <div class="cm-field-group">
            <label>Mobile Number</label>
            <input type="text" class="cm-input" [(ngModel)]="contactForm.mobileNumber" placeholder="+974XXXXXXXX" />
          </div>
          <div class="cm-field-group">
            <label>Landline Number</label>
            <input type="text" class="cm-input" [(ngModel)]="contactForm.landlineNumber" placeholder="+974XXXXXXXX" />
          </div>
          <div class="cm-field-group" *ngIf="contactModalMode === 'add'">
            <label>Role</label>
            <select class="cm-input" [(ngModel)]="contactForm.contactType">
              <option value="Primary" [disabled]="hasPrimaryContact()">Primary</option>
              <option value="Secondary">Secondary</option>
            </select>
          </div>
          <div class="cm-field-group" *ngIf="contactModalMode === 'add' && false">
            <label>Password</label>
            <div class="password-field">
              <input [type]="showPassword ? 'text' : 'password'" class="cm-input" [(ngModel)]="contactForm.password" placeholder="Enter password" />
              <button type="button" class="password-toggle-btn" (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                <i class="fas" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
              </button>
            </div>
          </div>
          <div class="cm-field-group" *ngIf="contactModalMode === 'add' && false">
            <label>Confirm Password</label>
            <div class="password-field">
              <input [type]="showConfirmPassword ? 'text' : 'password'" class="cm-input" [(ngModel)]="contactForm.confirmPassword" placeholder="Confirm password" />
              <button type="button" class="password-toggle-btn" (click)="toggleConfirmPasswordVisibility()" [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'">
                <i class="fas" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="contact-modal-footer">
        <button class="cm-cancel-btn" (click)="closeContactModal()">Cancel</button>
        <button class="cm-save-btn" (click)="saveContact()">
          {{ contactModalMode === 'add' ? 'Add Contact' : 'Save Changes' }}
        </button>
      </div>
    </div>

    <!-- =================== PASSWORD MODAL =================== -->
    <div class="contact-modal-overlay" *ngIf="showPasswordModal" (click)="closePasswordModal()"></div>
    <div class="contact-modal password-modal" *ngIf="showPasswordModal">
      <div class="contact-modal-header">
        <h5 class="mb-0">Update Password</h5>
        <button class="modal-close-btn" (click)="closePasswordModal()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="#333" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="contact-modal-body">
        <div class="password-contact-summary" *ngIf="passwordTargetContact">
          <span>{{ passwordTargetContact.name || passwordTargetContact.Name || 'Contact person' }}</span>
          <small>{{ passwordTargetContact.email || passwordTargetContact.Email }}</small>
        </div>
        <div class="cm-field-grid single-col">
          <div class="cm-field-group">
            <label>Password <span class="required-star">*</span></label>
            <div class="password-field">
              <input [type]="showPassword ? 'text' : 'password'" class="cm-input" [(ngModel)]="passwordForm.password" placeholder="Enter password" />
              <button type="button" class="password-toggle-btn" (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                <i class="fas" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
              </button>
            </div>
          </div>
          <div class="cm-field-group">
            <label>Confirm Password <span class="required-star">*</span></label>
            <div class="password-field">
              <input [type]="showConfirmPassword ? 'text' : 'password'" class="cm-input" [(ngModel)]="passwordForm.confirmPassword" placeholder="Confirm password" />
              <button type="button" class="password-toggle-btn" (click)="toggleConfirmPasswordVisibility()" [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'">
                <i class="fas" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="contact-modal-footer">
        <button class="cm-cancel-btn" (click)="closePasswordModal()">Cancel</button>
        <button class="cm-save-btn" (click)="saveContactPassword()">Update Password</button>
      </div>
    </div>

    <!-- =================== REMOVE CONTACT MODAL =================== -->
    <div class="contact-modal-overlay" *ngIf="showRemoveContactModal" (click)="closeRemoveContactModal()"></div>
    <div class="contact-modal remove-contact-modal" *ngIf="showRemoveContactModal">
      <div class="contact-modal-header">
        <h5 class="mb-0">Remove Contact</h5>
        <button class="modal-close-btn" (click)="closeRemoveContactModal()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="#333" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="contact-modal-body">
        <div class="remove-contact-message">
          <strong>{{ getRemoveContactDisplayName() }}</strong>
          <span>This contact person will be removed from the vendor.</span>
        </div>
      </div>
      <div class="contact-modal-footer">
        <button class="cm-cancel-btn" (click)="closeRemoveContactModal()">Cancel</button>
        <button class="reject-confirm-btn" (click)="confirmRemoveContact()">Remove</button>
      </div>
    </div>

    <!-- =================== BANK ACCOUNTS TAB =================== -->
    <ng-container *ngIf="activeTab === 'BankAccounts'">
      <div class="section-card mt-3">
        <h5 class="section-title">Bank Accounts</h5>
        <ng-container *ngIf="bankAccounts.length; else noBankAccounts">
          <div class="bank-cards">
            <div class="bank-card" *ngFor="let b of bankAccounts">
              <div class="bank-card-header">
                <span class="bank-name">{{ getBankDisplayName(b) }}</span>
                <div class="bank-header-actions">
                  <span class="bank-status-badge" [ngClass]="(b.status || b.Status || '').toLowerCase()">{{ b.status || b.Status || 'Active' }}</span>
                </div>
              </div>
              <div class="bank-card-body">
                <div class="bank-info-panel">
                  <div class="field-grid mt-2">
                    <div class="field-group"><label>Bank Name</label><div class="field-value">{{ getBankDisplayName(b) }}</div></div>
                    <div class="field-group"><label>Bank Account No</label><div class="field-value">{{ getBankAccountDisplayValue(b, ['accountNumber', 'AccountNumber']) }}</div></div>
                    <div class="field-group"><label>IBAN</label><div class="field-value">{{ getBankAccountDisplayValue(b, ['bankIBAN', 'BankIBAN', 'iban', 'IBAN', 'Iban']) }}</div></div>
                    <div class="field-group"><label>Swift Code / BIC</label><div class="field-value">{{ getBankAccountDisplayValue(b, ['swift', 'Swift', 'swiftCode', 'SwiftCode']) }}</div></div>
                    <div class="field-group"><label>Branch Name</label><div class="field-value">{{ getBankAccountDisplayValue(b, ['branch', 'Branch', 'branchName', 'BranchName']) }}</div></div>
                    <div class="field-group"><label>Beneficiary Account Name</label><div class="field-value">{{ getBankAccountDisplayValue(b, ['beneficiaryName', 'BeneficiaryName']) }}</div></div>
                    <div class="field-group"><label>Country</label><div class="field-value">{{ getBankAccountDisplayValue(b, ['countryRegionIdName', 'CountryRegionIdName', 'countryName', 'CountryName', 'country', 'Country', 'bankCountry', 'BankCountry']) }}</div></div>
                    <div class="field-group"><label>Currency</label><div class="field-value">{{ getBankAccountDisplayValue(b, ['currencyCodeName', 'CurrencyCodeName', 'currencyCode', 'CurrencyCode', 'currency', 'Currency']) }}</div></div>
                    <div class="field-group"><label>Email for Financial Communication</label><div class="field-value">{{ getBankAccountDisplayValue(b, ['email', 'Email', 'financeEmail', 'FinanceEmail']) }}</div></div>
                    <div class="field-group"><label>Address</label><div class="field-value">{{ getBankAccountDisplayValue(b, ['address', 'Address']) }}</div></div>
                    <div class="field-group"><label>Active Date</label><div class="field-value">{{ b.activeDate || b.ActiveDate ? formatDate(b.activeDate || b.ActiveDate) : '-' }}</div></div>
                    <div class="field-group"><label>Expiry Date</label><div class="field-value">{{ b.expiryDate || b.ExpiryDate ? formatDate(b.expiryDate || b.ExpiryDate) : '-' }}</div></div>
                  </div>
                  <div class="rejection-comments-box mt-3 d-none" *ngIf="isBankAccountRejected(b) && getBankAccountRejectionComments(b)">
                    <label>Rejection Comments</label>
                    <p>{{ getBankAccountRejectionComments(b) }}</p>
                  </div>
                  <div class="bank-documents mt-3">
                    <div class="bank-documents-header">
                      <span>Documents</span>
                    </div>
                    <div class="doc-groups" *ngIf="getBankAccountDocumentGroups(b).length; else noBankDocs">
                      <div class="doc-group-card" *ngFor="let group of getBankAccountDocumentGroups(b)">
                        <div class="doc-group-header">
                          <span class="doc-group-label">{{ group.label }}</span>
                          <span class="doc-count-badge">{{ group.files.length }} {{ group.files.length === 1 ? 'file' : 'files' }}</span>
                        </div>
                        <div class="doc-file" *ngFor="let doc of group.files">
                          <span class="doc-filename">{{ getDocumentName(doc) }}</span>
                          <span class="doc-expiry" *ngIf="getDocumentExpiryDate(doc)">Expiry: {{ getDocumentExpiryDate(doc) ? formatDate(getDocumentExpiryDate(doc)) : '-' }}</span>
                          <div class="doc-actions" *ngIf="getDocumentUrl(doc)">
                            <a [href]="getDocumentUrl(doc)" target="_blank" class="doc-btn view-btn">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="#532E60" stroke-width="2"/><circle cx="12" cy="12" r="3" stroke="#532E60" stroke-width="2"/></svg>
                              View
                            </a>
                            <a [href]="getDocumentUrl(doc)" download class="doc-btn dl-btn">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#532E60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 10L12 15L17 10" stroke="#532E60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 15V3" stroke="#532E60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                              Download
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-template #noBankDocs><p class="empty-text mb-0">No documents uploaded.</p></ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noBankAccounts><p class="empty-text">No bank accounts found.</p></ng-template>
      </div>
    </ng-container>

    <!-- =================== WORKFLOW TAB =================== -->
    <ng-container *ngIf="activeTab === 'Workflow'">
      <div class="workflow-status-banner mt-3" *ngIf="workflowData">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="3" fill="white"/><path d="M3 12H3.01M21 12H21.01M12 3V3.01M12 21V21.01M5.636 5.636L5.643 5.643M18.364 18.364L18.371 18.371M5.636 18.364L5.643 18.357M18.364 5.636L18.371 5.643" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>
        Workflow Status: <span class="wf-status-badge" [ngClass]="getVendorStatusClass(workflowData.status || workflowData.Status)">{{ normalizeVendorStatus(workflowData.status || workflowData.Status) }}</span>
        <span class="workflow-blocker-text" *ngIf="workflowTaskStatusText">{{ workflowTaskStatusText }}</span>
        <div class="workflow-actions ms-auto" *ngIf="canCreateWorkflowChildTask || canSendWorkflowReminder || canApproveVendorWorkflow || canRejectVendorWorkflow || canRequestVendorChange">
          <button class="workflow-task-btn" *ngIf="canCreateWorkflowChildTask" (click)="openWorkflowTaskModal()">Create Task</button>
          <button class="workflow-reminder-btn" *ngIf="canSendWorkflowReminder" (click)="confirmSendWorkflowReminder()">Send Reminder</button>
          <button class="workflow-approve-btn" *ngIf="canApproveVendorWorkflow" (click)="approveVendor()">Approve</button>
          <button class="workflow-task-btn" *ngIf="canRequestVendorChange" (click)="openChangeRequestVendor()">Request Changes</button>
          <button class="workflow-reject-btn" *ngIf="canRejectVendorWorkflow" (click)="openRejectVendor()">Reject</button>
        </div>
      </div>

      <div class="section-card mt-3" *ngIf="workflowData && workflowChildTasks.length">
        <div class="workflow-card-header">
          <h5 class="section-title mb-0">Child Tasks</h5>
          <span class="workflow-current-step" *ngIf="hasPendingWorkflowChildTasks">Pending review</span>
        </div>

        <div class="workflow-task-list" *ngIf="workflowChildTasks.length">
          <div class="workflow-task-item" *ngFor="let task of workflowChildTasks">
            <div>
              <strong>{{ getWorkflowValue(task, ['title', 'Title']) || 'Vendor review task' }}</strong>
              <span>{{ getWorkflowValue(task, ['assignedToEmail', 'AssignedToEmail']) }}</span>
              <p *ngIf="getWorkflowValue(task, ['description', 'Description'])">{{ getWorkflowValue(task, ['description', 'Description']) }}</p>
              
              <div *ngIf="getWorkflowValue(task, ['completionComments', 'CompletionComments'])">
                <hr/>
                <p class="workflow-task-comments">
                  {{ getWorkflowValue(task, ['completionComments', 'CompletionComments']) }}
                </p>
              </div>
            </div>
            <div class="workflow-task-actions">
              <span class="wf-status-badge" [ngClass]="getWorkflowTaskStatusClass(task)">{{ getWorkflowValue(task, ['status', 'Status']) }}</span>
              <button
                class="workflow-approve-btn"
                type="button"
                *ngIf="getWorkflowValue(task, ['canComplete', 'CanComplete']) === true"
                (click)="completeWorkflowChildTask(task, 'Approved')">
                Approve Task
              </button>
              <button
                class="workflow-reject-btn"
                type="button"
                *ngIf="getWorkflowValue(task, ['canComplete', 'CanComplete']) === true"
                (click)="openRejectWorkflowChildTask(task)">
                Reject Task
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="section-card mt-3" *ngIf="workflowData">
        <div class="workflow-card-header">
          <h5 class="section-title mb-0">Vendor Process Timeline</h5>
          <span class="workflow-current-step" *ngIf="workflowData.status === 'Submitted'">Waiting for {{ currentWorkflowApprovalStepName }}</span>
        </div>
        <div class="rejection-comments-box mb-3" *ngIf="isVendorRejected && vendorRejectionComments">
          <label>Rejection Comments</label>
          <p>{{ vendorRejectionComments }}</p>
        </div>
        <div class="timeline">
          <div class="tl-item" *ngFor="let item of workflowTimeline; let last = last">
            <div class="tl-left">
              <div class="tl-circle" [class.done]="item.done" [class.pending]="!item.done" [class.rejected]="item.rejected">
                <svg *ngIf="item.done" width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17L4 12" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <svg *ngIf="!item.done" width="12" height="12" viewBox="0 0 24 24" fill="none"><rect x="5" y="3" width="14" height="18" rx="2" stroke="#9CA3AF" stroke-width="2"/><path d="M9 7H15M9 11H15M9 15H12" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round"/></svg>
              </div>
              <div class="tl-line" *ngIf="!last"></div>
            </div>
            <div class="tl-content">
              <span class="tl-label">{{ item.label }}</span>
              <span class="tl-by">{{ item.by }}</span>
              <span class="tl-status" *ngIf="item.statusText">{{ item.statusText }}</span>
              <span class="tl-date" *ngIf="item.date">{{ formatDate(item.date) }}</span>
              
              <div>
                <hr *ngIf="item.rejected">
                <span class="tl-comments" *ngIf="item.comments">{{ item.comments }}</span>
              </div>
              
              <span class="tl-assigned" *ngIf="item.assignedTo && !item.done">Assigned to: <strong>{{ item.assignedTo }}</strong></span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- =================== CHILD TASK MODAL =================== -->
    <div class="contact-modal-overlay" *ngIf="showWorkflowTaskModal" (click)="closeWorkflowTaskModal()"></div>
    <div class="contact-modal workflow-task-modal" *ngIf="showWorkflowTaskModal">
      <div class="contact-modal-header">
        <h5 class="mb-0">Create Child Task</h5>
        <button class="modal-close-btn" (click)="closeWorkflowTaskModal()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="#333" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="contact-modal-body">
        <div class="workflow-task-form modal-task-form">
          <div class="cm-field-group">
            <label>Assigned User Email <span class="required-star">*</span></label>
            <input class="cm-input" type="email" [(ngModel)]="workflowChildTaskForm.assignedToEmail" placeholder="name@bidaya.com">
          </div>
          <div class="cm-field-group">
            <label>Title</label>
            <input class="cm-input" type="text" [(ngModel)]="workflowChildTaskForm.title" placeholder="Review vendor application">
          </div>
          <div class="cm-field-group col-full">
            <label>Description</label>
            <textarea class="cm-input" rows="4" [(ngModel)]="workflowChildTaskForm.description"></textarea>
          </div>
        </div>
      </div>
      <div class="contact-modal-footer">
        <button class="cm-cancel-btn" (click)="closeWorkflowTaskModal()">Cancel</button>
        <button class="workflow-approve-btn" (click)="createWorkflowChildTask()">Create Task</button>
      </div>
    </div>

    <!-- =================== REJECT MODAL =================== -->
    <div class="contact-modal-overlay" *ngIf="showRejectModal" (click)="closeRejectModal()"></div>
    <div class="contact-modal reject-modal" *ngIf="showRejectModal">
      <div class="contact-modal-header">
        <h5 class="mb-0">{{ getRejectModalTitle() }}</h5>
        <button class="modal-close-btn" (click)="closeRejectModal()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="#333" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="contact-modal-body">
        <div class="cm-field-group">
          <label>Comments <span class="required-star">*</span></label>
          <textarea class="cm-input reject-comments-input" [(ngModel)]="rejectionComments" rows="5" placeholder="Enter comments"></textarea>
        </div>
      </div>
      <div class="contact-modal-footer">
        <button class="cm-cancel-btn" (click)="closeRejectModal()">Cancel</button>
        <button class="reject-confirm-btn" (click)="submitRejection()">{{ getRejectConfirmText() }}</button>
      </div>
    </div>

  </div>
</div>
